import { LinkToOptionsType } from "@/modules/tasks/types";

export const TASKS_TABLE_COLUMNS_KEY = "tasksTableColumnVisibility";

export const defaultColumns = [
  "title",
  "type",
  "status",
  "dueDate",
  "creator",
  "assignee",
  "createdAt",
];

// Constants for Add Task functionality
export const TASK_FORM_DEFAULTS = {
  title: "",
  description: "",
  type: "",
  userUId: "",
  dueDate: "",
  selectedTime: "",
  linkedEntities: [] as any[],
};

export const FORM_STATE_DEFAULTS = {
  dueDate: null as Date | null,
  linkTo: null as LinkToOptionsType | null,
  linkToEntity: "",
  selectedTime: "",
};
// Toast messages
export const TOAST_MESSAGES = {
  ADD_TASK_SUCCESS: "Task added successfully!",
  ADD_TASK_ERROR: "Failed to add task!",
} as const;
